import React from 'react';

interface INoCompletedTripsProps {
	className?: string;
}

export const NoCompletedTrips = ({ className }: INoCompletedTripsProps) => {
	return (
		<svg width="301" height="160" viewBox="0 0 301 160" fill="none" className={className}>
			<circle cx="211" cy="68.502" r="6.5" fill="#EBEBEB" />
			<circle cx="200.5" cy="81.002" r="4" fill="#EBEBEB" />
			<circle cx="231.5" cy="42.002" r="20" fill="#EBEBEB" />
			<path
				d="M232.451 44.0645H230.286V43.1082C230.286 40.727 233.064 40.8395 233.064 39.1332C233.064 38.3457 232.523 37.7832 231.351 37.7832C231.044 37.7832 230.701 37.802 230.394 37.8395V39.2832H228.5V36.4707C229.366 36.1707 230.43 36.002 231.729 36.002C234.129 36.002 235.5 37.0332 235.5 38.9082C235.5 41.7207 232.451 41.552 232.451 43.352V44.0645ZM231.441 48.002C230.593 48.002 229.979 47.3082 229.979 46.502C229.979 45.6957 230.593 45.0395 231.441 45.0395C232.307 45.0395 232.92 45.6957 232.92 46.502C232.92 47.3082 232.307 48.002 231.441 48.002Z"
				fill="#A6A6A6"
			/>
			<g clipPath="url(#clip0_18217_116951)">
				<path
					d="M56.2967 143.905H227.894C227.894 143.905 231.732 118.076 219.713 106.009C203.856 90.153 167.294 82.4741 159.013 57.1438C150.731 31.8136 105.685 28.8218 85.3844 50.1631C65.0836 71.5043 88.2123 81.078 60.5386 99.7266C32.8649 118.375 56.2967 143.905 56.2967 143.905Z"
					fill="#EBEBEB"
				/>
				<path
					d="M105.25 87.5769L178.942 92.0273C184.931 92.389 190.53 95.085 194.505 99.5222C198.481 103.959 200.509 109.774 200.143 115.688L198.928 135.297C198.833 136.828 198.126 138.26 196.963 139.276C195.799 140.293 194.274 140.811 192.723 140.717L87.5781 134.368C86.0274 134.274 84.5779 133.576 83.5484 132.427C82.519 131.278 81.9939 129.772 82.0888 128.241L83.4329 106.541C83.7921 101.175 86.2889 96.167 90.3773 92.6132C94.4657 89.0593 99.813 87.2485 105.25 87.5769Z"
					fill="white"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M110.634 110.298L90.9394 109.101C90.4927 109.089 90.0531 108.987 89.6468 108.804C89.2406 108.62 88.8758 108.358 88.5743 108.032C88.2728 107.707 88.0407 107.324 87.8918 106.908C87.7428 106.492 87.6801 106.051 87.7074 105.611L87.9094 103.118C87.9589 102.206 88.219 101.317 88.67 100.52C89.121 99.7226 89.7508 99.0378 90.5112 98.518C91.2716 97.9982 92.1425 97.6572 93.057 97.521C93.9715 97.3848 94.9055 97.4571 95.7873 97.7324L108.008 101.422C108.896 101.671 109.671 102.212 110.203 102.956C110.736 103.7 110.995 104.602 110.937 105.511L110.634 110.298Z"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M173.354 113.988L193.049 115.184C193.487 115.211 193.926 115.153 194.341 115.012C194.756 114.871 195.139 114.65 195.467 114.363C195.795 114.076 196.063 113.728 196.255 113.338C196.447 112.948 196.559 112.525 196.584 112.093L196.786 109.6C196.832 108.683 196.667 107.768 196.304 106.923C195.941 106.078 195.389 105.325 194.69 104.721C193.99 104.117 193.161 103.676 192.265 103.433C191.369 103.19 190.428 103.15 189.514 103.317L176.99 105.511C176.096 105.666 175.28 106.115 174.675 106.784C174.07 107.454 173.712 108.305 173.657 109.201L173.354 113.988Z"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M173.667 108.607L110.761 104.808L110.422 110.279L173.328 114.078L173.667 108.607Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M142.247 109.599C144.088 109.599 145.58 108.126 145.58 106.309C145.58 104.491 144.088 103.018 142.247 103.018C140.406 103.018 138.914 104.491 138.914 106.309C138.914 108.126 140.406 109.599 142.247 109.599Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M99.1348 121.023L183.009 126.089L182.972 126.686C182.833 128.93 181.797 131.027 180.092 132.517C178.386 134.007 176.152 134.767 173.879 134.629L107.143 130.599C104.87 130.462 102.746 129.439 101.237 127.755C99.7282 126.071 98.9588 123.865 99.0978 121.621L99.1348 121.023Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M170.527 65.1218L119.522 62.0304C114.573 61.7312 109.726 64.4238 106.696 69.3103L99.2217 86.7623L187 94.002L182.445 73.798C180.021 68.6122 175.577 65.421 170.527 65.1218Z"
					fill="#ffcc00"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M95.4838 78.3121L91.4513 78.0686C89.7254 77.9644 88.2406 79.2614 88.135 80.9656L88.1313 81.0253C88.0258 82.7295 89.3394 84.1956 91.0654 84.2998L95.0978 84.5433C96.8237 84.6476 98.3085 83.3505 98.414 81.6463L98.4177 81.5866C98.5233 79.8824 97.2097 78.4164 95.4838 78.3121Z"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M195.925 84.358L191.893 84.1145C190.167 84.0103 188.682 85.3073 188.576 87.0115L188.573 87.0712C188.467 88.7754 189.781 90.2415 191.507 90.3457L195.539 90.5892C197.265 90.6935 198.75 89.3964 198.855 87.6922L198.859 87.6325C198.965 85.9283 197.651 84.4623 195.925 84.358Z"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M100.837 144.005H84.4756L85.1826 133.833L101.5 135.502L100.837 144.005Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
				<path
					d="M170.526 65.1223L119.522 62.0308C117.538 61.9621 115.563 62.3188 113.732 63.0763C111.901 63.8338 110.259 64.9741 108.917 66.4187L180.525 70.7069C179.375 69.1089 177.884 67.7802 176.156 66.8151C174.428 65.85 172.506 65.2721 170.526 65.1223Z"
					fill="white"
					stroke="#A3A3A3"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M69.8311 144.005H212.946" stroke="#A3A3A3" strokeWidth="2" />
				<path
					d="M194.71 140.872H194.213L178.798 140.002L178.5 144.002H194.71C195.185 144.002 195.64 143.837 195.976 143.544C196.311 143.25 196.5 142.852 196.5 142.437C196.5 142.022 196.311 141.623 195.976 141.33C195.64 141.036 195.185 140.872 194.71 140.872Z"
					fill="#EBEBEB"
					stroke="#A3A3A3"
					strokeWidth="2"
				/>
			</g>
			<defs>
				<clipPath id="clip0_18217_116951">
					<rect width="182" height="109" fill="white" transform="translate(46.5 36.002)" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default NoCompletedTrips;
